define('modules/editor/behaviours/toolbar',['require','exports','module','common/models/appstate','../models/editorstate','../views/edit_element_popup','i18n','common/views/confirmation_popup'],function(require, exports, module) {
  "use strict";

  var AppState = require("common/models/appstate"),
      EditorState = require("../models/editorstate"),
      EditElementPopup = require("../views/edit_element_popup"),
      i18n = require("i18n"),
      ConfirmationPopup = require("common/views/confirmation_popup");

  var toolbarEvents = {
    "click .js-edit": "_editActiveItem",
    "click .js-edit-content": "_editContent",
    "click .js-delete": "_deleteActiveItem",
    //move sections
    "click .js-section-up": "_moveSectionUp",
    "click .js-section-down": "_moveSectionDown",
    //move elements
    "click .js-element-up": "_moveUpElement",
    "click .js-element-down": "_moveDownElement",
    // duplicate element
    "click .js-duplicate": "_duplicateActiveItem"
  };

  module.exports = {
    _editActiveItem: function(e) {
      e.preventDefault();
      e.stopPropagation();
      var selectedElementModel = EditorState.activeItemState.getActiveItem();
      selectedElementModel = selectedElementModel.formModel || selectedElementModel;
      new EditElementPopup({
        page: this._page,
        item: selectedElementModel
      });
    },
    _editContent: function(e){
      var elementView = EditorState.getSelectedElement();
      if(elementView){
        elementView.triggerMethod("edit:content");
      }
    },
    _deleteActiveItem: function(e) {
      e.preventDefault();
      e.stopPropagation();
      ConfirmationPopup.show({
        title: $.i18n.t("editor.confirmItemDeletion.title"),
        message: $.i18n.t("editor.confirmItemDeletion.message")
      })
      .then(_.bind(this._page.deleteSelectedItem, this._page));
    },
    _moveSectionUp: function(e) {
      e.preventDefault();
      e.stopPropagation();
      this._page.moveSectionUp();
    },
    _moveSectionDown: function(e) {
      e.preventDefault();
      e.stopPropagation();
      this._page.moveSectionDown();
    },
    _moveUpElement: function(e){
      e.preventDefault();
      e.stopPropagation();
      this._page.moveUpElement();
    },
    _moveDownElement: function(e){
      e.preventDefault();
      e.stopPropagation();
      this._page.moveDownElement();
    },
    _duplicateActiveItem: function(e){
      e.preventDefault();
      e.stopPropagation();
      this._page.duplicateSelectedItem();
    },
    mixed: function(klass, proto) {
      proto.events = _.extend(proto.events || {}, toolbarEvents);
      proto.initialize = _.wrap(proto.initialize || _.identity, function(init) {
        this._page = EditorState.getActivePage();
        return init.apply(this, _.rest(arguments));
      });
    }
  };

});

